import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/context/AuthContext";
import { FiscalYearProvider } from "@/context/FiscalYearContext";
import { PeriodProvider } from "@/context/PeriodContext";
import { ColumnPrefsProvider } from "@/context/ColumnPrefsContext";
import { applyViewMode } from "@/components/ViewModeToggle";

applyViewMode();   // phones: honour the saved "Desktop view" choice before first paint

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

// The API only trusts its own origin (strict CORS + SameSite cookies). A user who opens the app on any other
// host (e.g. the raw *.emergent.host URL instead of erp.copprrod.com) is sent to the canonical one, path + sign-in hash intact.
const canonical = (() => { try { return new URL(process.env.REACT_APP_BACKEND_URL).origin; } catch { return null; } })();
if (canonical && canonical !== window.location.origin && window.location.hostname !== "localhost") {
  window.location.replace(canonical + window.location.pathname + window.location.search + window.location.hash);
}

// Installable app (PWA): see lib/pwa.js — switch is server-side (backend PWA_MODE: 0 · admin · 1); InstallAppButton asks /api/pwa/status.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <FiscalYearProvider>
        <PeriodProvider>
        <ColumnPrefsProvider>
          <App />
        </ColumnPrefsProvider>
        </PeriodProvider>
      </FiscalYearProvider>
    </AuthProvider>
  </QueryClientProvider>
);
